module.exports = __webpack_public_path__ + "static/media/POSTRAK_2024.1c0cd004.pdf";